import Footer from "common/src/components/Footer";
import Navbar from "./Navbar";
import { classNames } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DefaultLayout(_ref) {
  let {
    showWalletInteraction = true,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("main", {
    className: "font-sans min-h-screen text-grey-500",
    children: [/*#__PURE__*/_jsx(Navbar, {
      showWalletInteraction: showWalletInteraction
    }), /*#__PURE__*/_jsx("div", {
      className: "container pt-16 relative z-10 mx-auto px-4 sm:px-6 lg:px-20 max-w-screen-2xl",
      children: children
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
}
export function RoundViewLayout(_ref2) {
  let {
    showWalletInteraction = true,
    children,
    infoCard
  } = _ref2;
  return /*#__PURE__*/_jsxs("main", {
    className: "font-sans min-h-screen text-grey-500",
    children: [/*#__PURE__*/_jsx(Navbar, {
      showWalletInteraction: showWalletInteraction
    }), infoCard && /*#__PURE__*/_jsx("div", {
      className: "relative pt-16 w-full items-center",
      children: infoCard
    }), /*#__PURE__*/_jsx("div", {
      className: classNames("container relative z-10 mx-auto px-4 sm:px-6 lg:px-20 max-w-screen-2xl", infoCard ? "pt-0" : "pt-16"),
      children: children
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
}
export function GradientLayout(_ref3) {
  let {
    showWalletInteraction = true,
    showAlloVersionBanner = false,
    children
  } = _ref3;
  return /*#__PURE__*/_jsxs("main", {
    className: "font-sans min-h-screen bg-gradient-to-b from-[#D3EDFE] to-[#FFD9CD]",
    children: [/*#__PURE__*/_jsx(Navbar, {
      showWalletInteraction: showWalletInteraction,
      showAlloVersionBanner: showAlloVersionBanner
    }), /*#__PURE__*/_jsx("div", {
      className: classNames("mx-auto w-full relative z-10 px-4 sm:px-6 lg:px-20", showAlloVersionBanner ? "pt-[120px]" : "pt-16"),
      style: {
        background: "linear-gradient(180deg, #ADEDE5 -13.57%, rgba(21, 184, 220, 0.47) 45.05%, rgba(0,0,0,0) 92.61%)"
      },
      children: children
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
}